import React, { Fragment } from 'react'
import PaginatedConnectionTable from 'components/PaginatedConnectionTable'
import graphqlQuery from 'graphs/queries/CompaniesPaginated.graphql'
import withConnectionQuery from 'components/withConnectionQuery'
import fields from 'fields/companies'
import { Mutation } from 'react-apollo'
import toggleUserCompany from 'graphs/mutations/toggleUserCompany.graphql'
import CompanyFragment from 'graphs/fragments/CompanyFields.graphql'
import SwitchWithMutation from 'components/SwitchWithMutation'

const RouteUsers = ({ variables, ...props }) => (
  <Mutation mutation={toggleUserCompany}>
    {mutate => (
      <Fragment>
        <h3>Companies</h3>
        <PaginatedConnectionTable
          {...props}
          fields={[
            {
              props: {
                dataKey: 'manage',
                key: 'manage',
                render: data => (
                  <SwitchWithMutation
                    initialValue={data.has_user}
                    id={`row-${data.id}`}
                    mutate={mutate}
                    buildMutationOptions={value => ({
                      variables: {
                        input: {
                          company_id: data.id,
                          user_id: variables.user_id,
                          value
                        },
                        user_id: variables.user_id
                      },
                      update: (store, { data: { toggle_user_company } }) => {
                        store.writeFragment({
                          id: data.id,
                          fragment: CompanyFragment,
                          variables,
                          data: toggle_user_company
                        })
                      }
                    })}
                    {...props}
                  />
                )
              }
            },
            ...fields
          ]}
          manage
          onRowClick={() => {}}
        />
      </Fragment>
    )}
  </Mutation>
)

export default withConnectionQuery({
  graphqlQuery,
  paginated: true,
  namespace: 'companies'
})(RouteUsers)



// WEBPACK FOOTER //
// ./src/routes/admin/users/companies/manage.js